import { useScopeParams } from "./useScopeParams";
import { getScopePathSegmentIndex } from "../utils/scopeRouting";

export const usePathNavigation = (
  path: { pathname: string },
  defaultLandingPage: string = "/subjects",
): { openMenu: string; newPathname: string } => {
  const { scope } = useScopeParams();
  const pathParts = path.pathname.split("/");
  const segmentIndex = getScopePathSegmentIndex(scope);
  const openMenu = pathParts[segmentIndex]
    ? "/" + pathParts[segmentIndex]
    : defaultLandingPage;
  const newPathname = pathParts[segmentIndex]
    ? "/" + pathParts.slice(segmentIndex).join("/")
    : defaultLandingPage + "/overview";

  return { openMenu, newPathname };
};
